import Chip from '@mui/material/Chip';
import i18n from 'app-i18n';
import { STATUSES } from 'appConstants';

interface chipObj {
  [x: string]:
    | 'success'
    | 'default'
    | 'error'
    | 'warning'
    | 'info'
    | 'primary'
    | 'secondary';
}

const chipColors: chipObj = {
  [STATUSES.SUCCEEDED]: 'success',
  [STATUSES.REFUNDED]: 'warning',
  [STATUSES.PARTIALLY_REFUNDED]: 'warning',
  [STATUSES.REFUND_PENDING]: 'info',
  [STATUSES.REFUND_FAILED]: 'error',
  [STATUSES.FAILED]: 'error',
};

const STATUS_MAP = {
  SUCCEEDED: () =>
    i18n.t('page.transactions.filters.statusFilter.successful.label'),
  REFUNDED: () =>
    i18n.t('page.transactions.filters.statusFilter.refunded.label'),
  PARTIALLY_REFUNDED: () =>
    i18n.t('page.transactions.filters.statusFilter.partiallyRefunded.label'),
  REFUND_PENDING: () =>
    i18n.t('page.transactions.filters.statusFilter.refundPending.label'),
  REFUND_FAILED: () =>
    i18n.t('page.transactions.filters.statusFilter.refundFailed.label'),
  FAILED: () =>
    i18n.t('page.transactions.filters.statusFilter.paymentFailed.label'),
};

const TransactionStatusChip = ({ status }) => {
  if (!status || !chipColors[status]) return null;

  return (
    <Chip
      label={STATUS_MAP[status]()}
      color={chipColors[status]}
      size="small"
    />
  );
};

export default TransactionStatusChip;
